import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeJagoUserId extends ChangeBusinessDetails {
  type: string = 'ChangeJagoUserId';
}
